var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__header calendar-header"},[_c('span',{staticClass:"custom-icon--calendar calendar-header__icon"}),_vm._v(" "),_c('span',[_vm._v("Kiedy?")]),_vm._v(" "),_c('span',{staticClass:"custom-icon--cross calendar-header__icon",on:{"click":function($event){return _vm.$emit('close')}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56af802e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/MobileHeader.vue
// module id = 626
// module chunks = 1